import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta11 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-11/utils-consultaSeguimentoPergunta11'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMchatExemplosPassouFalhouTableItem } from '../components/HistoricoMchatExemplosPassouFalhouTableItem'
import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleHorizontalTableItem } from '../components/HistoricoMChatSimpleHorizontalTableItem'
import { convertAplicacaoPergunta11 } from './converter-HistoricoMchatPergunta11'

interface HistoricoMChatRfPergunta11Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta11 = (props: Readonly<HistoricoMChatRfPergunta11Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta11(aplicacoes)
  if (converted == null) return null

  const { header, exemplosPassou, exemplosFalhou, perguntaMaiorFrequencia, model } = converted
  if (header === null) return null

  const exibirPassouFalhou = exemplosPassou.length > 0 || exemplosFalhou.length > 0
  const exibirPergunta = exibirPassouFalhou ? '“Seu filho...”' : undefined

  const resultado = calculateResultadoPergunta11(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='11'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={exibirPergunta}
        perguntaSecundaria='“Ele sempre...”'
      />
      {exibirPassouFalhou && (
        <HistoricoMchatExemplosPassouFalhouTableItem exemplosPassou={exemplosPassou} exemplosFalhou={exemplosFalhou} />
      )}
      {perguntaMaiorFrequencia && (
        <HistoricoMChatSimpleHorizontalTableItem
          pergunta={perguntaMaiorFrequencia.textoPergunta + ':'}
          resposta={'Exemplos ' + (perguntaMaiorFrequencia.stPassou ? 'PASSOU' : 'FALHOU')}
        />
      )}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
